import React from 'react';
import classes from './Gallery.module.scss';

import { Row } from 'reactstrap';

const gallery = (props) => {
    return (
        <Row className={props.isSignup ? '' : classes.Slider}>
            {props.children}
        </Row>
    );
};

export default gallery;
